import general from './general';
const translationUk = {
  ...general,
};

export default translationUk;
